'use client'
import React, {useState, useContext, useEffect, useCallback } from 'react';
import { Box, Flex, Text, Divider } from '@chakra-ui/layout';
import PersonaAsideEditMenu from './personaAsideEditMenu';
import { PersonaContext } from '../../lib/personaContext';
import { MdArrowBack } from 'react-icons/md';
import { IconButton } from '@chakra-ui/react';
import ProductInPersonaList from '@/persona/[id]/components/productInPersonaList';
import PersonaNameForm from './personaNameForm';
import InlineFormWrapper from '@/components/inlineFormWrapper';
import PersonaAsideQuote from './personaAsideQuote';
import PersonaAttributes from './personaAttributes';
import { useTheme } from '@emotion/react';
import PersonaAsideThumbnail from './personaAsideThumbnail';
import { useSmartBackToPreviousPath } from '../../../lib/useSmartBackToPreviousPath';
import { PersonaPageContext } from '../lib/personaPageContext';
import PersonaAsideUsefulLinks from './personaAsideUsefulLinks';
import SharedExperiencesInPersonaList from './sharedExperiencesInPersonaList';
export default function PersonaAside(props) {
  const theme = useTheme();
  const {
    persona,
    rights,
  } = useContext(PersonaContext);
  const {
    editingQuote,
    editingAttributes,
    editingUsefulLinks,
    sharedExperienceList,
    addingSharedExperience,
  } = useContext(PersonaPageContext);
  const [space, setSpace] = useState();
  const goBack = useSmartBackToPreviousPath();

  useEffect(() => {
    if (theme) {
      const spaceCurrent = parseInt(theme.space[3].replace('px', ''));
      setSpace((spaceCurrent * 2))
    }
  }, [theme])
  return (
    <>
      {persona && (
        <Flex
          flexShrink={"0"}
          w="275px"
          borderRight="1px"
          borderColor="divider.grey"
          borderRadius="2px"
          backgroundColor="white"
          alignItems={'stretch'}
          flexDirection={'column'}
          gap={3}
          position="relative"
          overflow={"auto"}
          py={3}
        >
          <IconButton
            left={1}
            top={1}
            position="absolute"
            variant="greyTransparent"
            icon={<MdArrowBack />}
            size="lg"
            onClick={goBack}
          />
          <Flex
            flexDirection={"column"}
            alignItems={'center'}
            gap={2}
            mb={1}
          >
            <PersonaAsideThumbnail />
            <InlineFormWrapper
              canEdit={rights.can_update}
              value={
                <Text
                  px={3}
                  fontSize={20}
                  color="fill.blue"
                  textAlign={"center"}
                >
                  {persona.name}
                </Text>
              }
            >
              {(close) => (
                <PersonaNameForm
                  onSubmitted={close}
                  onCancel={close}
                />
              )}
            </InlineFormWrapper>
            <PersonaAsideEditMenu />
          </Flex>
          {(persona.quote || editingQuote) && (
            <>
              <Divider ml={3} variant="blue" width={"calc(100% - " + space + "px)"} />
              <Flex px={3} width={"100%"}>
                <PersonaAsideQuote />
              </Flex>
            </>
          )}
          {((persona.job
            || persona.location
            || persona.age
            || persona.education
            || persona.fammily_status
            || persona.interests
          ) || editingAttributes)
            && (
              <>
                <Divider ml={3} variant="blue" width={"calc(100% - " + space + "px)"} />
                <Flex px={3} w={"100%"}>
                  <PersonaAttributes />
                </Flex>
              </>
            )}
          <Divider ml={3} variant="blue" width={"calc(100% - " + space + "px)"} />
          <Box w="100%">
            <ProductInPersonaList personaId={persona.id} />
          </Box>
          {((sharedExperienceList && sharedExperienceList.length > 0) || addingSharedExperience) && (
            <>
              <Divider ml={3} variant="blue" width={"calc(100% - " + space + "px)"} />
              <Box w="100%">
                <SharedExperiencesInPersonaList 
                  personaId={persona.id} 
                />
              </Box>
            </>
          )}
          {(persona.useful_links && persona.useful_links.length > 0) || editingUsefulLinks ? (
            <>
              <Divider ml={3} variant="blue" width={"calc(100% - " + space + "px)"} />
              <PersonaAsideUsefulLinks />
            </>
          ) : null}
        </Flex>
      )}
    </>
  )
}
